<template>
  <RevCard class="p-24 md:col-span-9 lg:col-span-3">
    <OrderSummaryCardLine
      :label="i18n(translations.number)"
      :value="orderNumber"
    />

    <RevDivider class="my-16" />

    <OrderSummaryCardLine
      :label="i18n(translations.date)"
      :value="i18n.date(new Date(createdAt))"
    />

    <RevDivider class="my-16" />

    <OrderSummaryCardLine :label="i18n(translations.billingAddress)">
      <div class="text-static-default-hi body-2-bold mt-4">
        {{ `${billingAddress.firstName} ${billingAddress.lastName}` }}
      </div>
      <div class="text-static-default-hi text-body-2 mt-4">
        {{ billingAddress.street }}
      </div>
      <div class="text-static-default-hi text-body-2">
        {{ `${billingAddress.city} ${billingAddress.postalCode}` }}
      </div>
    </OrderSummaryCardLine>

    <RevDivider class="my-16" />

    <OrderSummaryCardLine :label="i18n(translations.payment)">
      <div class="mt-4 flex items-center gap-8">
        <IconCreditCard />
        <div>{{ i18n(translations.creditCard) }}</div>
      </div>
    </OrderSummaryCardLine>
  </RevCard>
</template>

<script setup lang="ts">
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevDivider } from '@ds/components/Divider'
import { IconCreditCard } from '@ds/icons/IconCreditCard'

import translations from './OrderSummaryCard.translations'
import OrderSummaryCardLine from './components/OrderSummaryCardLine/OrderSummaryCardLine.vue'

const i18n = useI18n()

defineProps<{
  orderNumber: string
  createdAt: string
  billingAddress: ApiSpecs['/api/gift-cards/v1/payments/:requestId/details']['GET']['response']['billingAddress']
}>()
</script>
